import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";
import type { CrmListsState } from "../type";
import * as crmListsActions from "../actions/crmListsActions";

const INITIAL_CRM_LISTS_STATE: CrmListsState = {
    lists: [],
    isFetching: false,
    fetchingError: null,
};

export const crmListsReducer = createReducer<CrmListsState, ActionType<typeof crmListsActions>>(INITIAL_CRM_LISTS_STATE)
    .handleAction(crmListsActions.fetchCrmListsAsync.request, (state) => ({
        ...state,
        isFetching: true,
        fetchingError: null,
    }))
    .handleAction(crmListsActions.fetchCrmListsAsync.success, (state, { payload }) => ({
        ...state,
        lists: payload,
        isFetching: false,
    }))
    .handleAction(crmListsActions.fetchCrmListsAsync.failure, (state, { payload }) => ({
        ...state,
        isFetching: false,
        fetchingError: payload,
    }));
